import mapSortFilterToRtpField from './helpers/mapSortFilterToRtpField';
import useGameList from './useGameList';
import useGameListVariables from './useGameListVariables';
import useRecommendedGamesList from './useRecommendedGamesList';
import useSelectedFiltersStore from '../../store/useSelectedFiltersStore';

type Args = {
  menuItem?: string;
  theme?: string;
  isLiveRtp?: boolean;
  isRecommendedGames?: boolean;
};

const useGames = ({ menuItem, theme, isLiveRtp, isRecommendedGames }: Args) => {
  const { categories, providers, sort } = useSelectedFiltersStore();

  const variables = useGameListVariables({
    menuItem,
    theme,
    categories,
    providers,
    sort: sort.value,
    sortType: sort.name,
  });

  const regularGames = useGameList(variables, isRecommendedGames);
  const recommendedGames = useRecommendedGamesList(!isRecommendedGames);
  const rtpField = mapSortFilterToRtpField(sort, isLiveRtp);
  const games = regularGames.gameList ?? recommendedGames.games;
  const loading = regularGames.loading || recommendedGames.loading;
  const providerName = games?.[0]?.node?.menuItem?.[0]?.name;

  return {
    rtpField,
    games,
    loading,
    providerName,
    onLoadMore: regularGames.onLoadMore,
    totalCount: regularGames.totalCount,
    step: regularGames.step,
    count: games?.length ?? 0,
  };
};

export default useGames;
